/** @jsx jsx */
import React, { memo } from 'react';
import { css, jsx } from '@compiled/react';
import Link from '@atlaskit/link';
import { token } from '@atlaskit/tokens';
import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';

export type Props = { issueKey: IssueKey };

export const KeyCell = memo<Props>(({ issueKey }: Props) => (
	<div css={nowrapStyle}>
		<Link appearance="subtle" href={`/browse/${issueKey}`}>
			{issueKey}
		</Link>
	</div>
));

const nowrapStyle = css({
	color: token('color.text'),
	whiteSpace: 'nowrap',
	fontWeight: token('font.weight.semibold'),
	textDecorationColor: token('color.text'),

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'a, a:visited, a:hover, a:visited:hover': {
		color: token('color.text'),
		textDecorationColor: token('color.text'),
	},
});
